module.exports = __webpack_public_path__ + "img/upgrade_tips.52191183.png";